// Module
var code = "<div class=\"kanban-item__secondary-info-item\"> <div class=\"transition kanban-item__action\">Action Name</div> <div class=\"kanban-item__date-badge kanban-item__date-badge--deadline\"> <i class=\"fa fa-clock-o\"></i> Jun 30 </div> </div>";
// Exports
export default code;